import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";
import { green, red } from "@mui/material/colors";
import React from "react";

function SmallDashboard({
  icon,
  iconColor,
  title,
  value,
  percent = 0,
  subtitle,
}) {
  return (
    <Card
      sx={{
        minHeight: 188,
        height: "100%",
        p: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        avatar={
          <Avatar sx={{ color: "#FFF", bgcolor: iconColor }} variant="circular">
            {icon}
          </Avatar>
        }
      />
      <CardContent sx={{ flexGrow: 1, py: 0 }}>
        <Typography color="text.secondary" variant="body1">
          {title}
        </Typography>
        <Stack mt={0.5} direction={"row"} spacing={1} alignItems={"center"}>
          <Typography variant="h5">{value}</Typography>
          <Typography color={percent >= 0 ? green[500] : red[300]}>
            {percent > 0 && "+"}
            {percent}%
          </Typography>
        </Stack>
      </CardContent>
      <CardActions sx={{ pt: 0 }}>
        <Typography color="text.secondary" variant="body2">
          {subtitle}
        </Typography>
      </CardActions>
    </Card>
  );
}

export default SmallDashboard;
